export default __webpack_public_path__ + "static/media/md-mail.a9180968.svg";